<template>

    <div class="d-flex flex-column justify-content-center align-item-center p-3">

        <div v-if="Object.values(allmediafiles).length > 0" class="order-1 d-flex flex-column">

            <span class="order-1"><strong>Apenas é permitido escolher 1 imagem</strong></span>
    
            <!--Add Display Grid-->
            <div class="order-2 d-flex flex-row" style="flex-wrap:wrap;">
    
                <figure v-for="(value, index) in allmediafiles" 
                    :key="value.id" 
                    style="width:20rem;height:20rem;margin-right:1rem;"
                    class="cardselectimg"
                    @click="chooseImage($event)"
                >
    
                   <img 
                    :src="value.filelink" 
                    :alt="value.filealt"
                    :data-filealt="value.filealt"
                    :data-fileext="value.fileext"
                    :data-filenamenew="value.filenamenew"
                    :data-filenameold="value.filenameold"
                    :data-fileid="value.id"
                    :data-thumb="value.thumb_exist"
                    :data-referid="index"
                    class="media-image"
                    style="width:inherit;height:100%;object-fit:fill;"
                    />
    
                   <figcaption>
                        <p>{{ value.filenameold }}</p>
                   </figcaption>
    
                </figure>
    
            </div>
    
        </div>
       
        <span v-else>Ainda não possui imagens para selecionar</span>

    </div>

</template>
<script>

    export default{
        name: "MediaListElement",
        emit: ['choose-image'],
        props:{
            
            allmediafiles:{
                type: Array,
                required: true
            }

        },
        /* data: () => {

            return {

                allmediafileslocalstorage: {}

            }

        },
        created(){

            //Set All Media
            //this.allmediafiles = JSON.parse(this.allmedia);
            this.allmediafileslocalstorage = localStorage.getItem('medialist');

            //Check Allmedia Files LocalStorage
            if(this.allmediafileslocalstorage && this.allmediafiles.length === 0){

                this.allmediafiles = JSON.parse(this.allmediafileslocalstorage);

            }

        }, */
        methods:{

            chooseImage(element){

                return this.$emit('choose-image', element);

            }


        }


    }

</script>